import InputField from '../../../components/Forms/Input/InputField';
import {
  mapReservationSettings,
  toReservationUpdateDTO,
} from './RestaurantSettingsMapper';
import RestaurantSettingsFormLayout from './RestaurantSettingsFormLayout';
import RestaurantSettingsToggle from './RestaurantSettingsToggle';
import RestaurantFormHelp from '../shared/RestaurantFormHelp';
import useRestaurantSettingsForm from './useRestaurantSettingsForm';

interface Props {
  branchId: number;
}

const RestaurantReservationSettingsForm = ({ branchId }: Props) => {
  const settings = useRestaurantSettingsForm(
    branchId,
    'reservations',
    mapReservationSettings,
    toReservationUpdateDTO
  );
  const { form, updateField } = settings;

  return (
    <RestaurantSettingsFormLayout
      title="Reservaciones"
      description="Políticas de disponibilidad, tolerancia y atención de reservaciones."
      loading={settings.loading}
      saving={settings.saving}
      hasData={Boolean(form)}
      alert={settings.alert}
      onCloseAlert={() => settings.setAlert(null)}
      onSave={settings.save}
      onRetry={settings.reload}
      help={<RestaurantFormHelp topic="settingsReservation" variant="inline" />}
    >
      {form && (
        <>
          <RestaurantSettingsToggle
            label="Reservaciones habilitadas"
            description="Permite recibir y administrar reservaciones en esta sucursal."
            name="reservations-enabled"
            checked={form.reservationsEnabled}
            onChange={() =>
              updateField('reservationsEnabled', !form.reservationsEnabled)
            }
          />
          <InputField
            label="Tolerancia (minutos)"
            iconKey="clock"
            name="reservationToleranceMinutes"
            type="number"
            min={0}
            max={1440}
            value={form.reservationToleranceMinutes}
            onChange={(event) =>
              updateField('reservationToleranceMinutes', Number(event.target.value))
            }
          />
          <InputField
            label="Máximo de días de anticipación"
            iconKey="calendar"
            name="maximumAdvanceDays"
            type="number"
            min={0}
            max={3650}
            value={form.maximumAdvanceDays}
            onChange={(event) =>
              updateField('maximumAdvanceDays', Number(event.target.value))
            }
          />
          <RestaurantSettingsToggle
            label="Cancelación automática"
            description="Cancela la reservación cuando se supera el tiempo de tolerancia."
            name="automatic-cancellation"
            checked={form.automaticCancellationEnabled}
            onChange={() =>
              updateField(
                'automaticCancellationEnabled',
                !form.automaticCancellationEnabled
              )
            }
          />
          <RestaurantSettingsToggle
            label="Permitir clientes invitados"
            description="Permite reservar sin un cliente previamente registrado."
            name="allow-guest-reservations"
            checked={form.allowGuestReservations}
            onChange={() =>
              updateField('allowGuestReservations', !form.allowGuestReservations)
            }
          />
          <RestaurantSettingsToggle
            label="Permitir varias mesas"
            description="Permite asignar más de una mesa a una reservación."
            name="allow-multiple-tables"
            checked={form.allowMultipleTables}
            onChange={() =>
              updateField('allowMultipleTables', !form.allowMultipleTables)
            }
          />
          <RestaurantSettingsToggle
            label="Overbooking"
            description="Permite aceptar reservaciones por encima de la capacidad calculada."
            name="allow-overbooking"
            checked={form.allowOverbooking}
            onChange={() => updateField('allowOverbooking', !form.allowOverbooking)}
          />
          <RestaurantSettingsToggle
            label="Recordatorios automáticos"
            description="Envía recordatorios de reservación cuando el canal está disponible."
            name="reservation-reminders"
            checked={form.sendReservationReminders}
            onChange={() =>
              updateField(
                'sendReservationReminders',
                !form.sendReservationReminders
              )
            }
          />
        </>
      )}
    </RestaurantSettingsFormLayout>
  );
};

export default RestaurantReservationSettingsForm;

